export default {"src":"/_next/static/media/set-spotswap-pay-mode-guide-en.92fdc158.gif","height":150,"width":600,"blurWidth":0,"blurHeight":0};